<!-- Promo Codes Manager Modal -->
<div v-if="inline">
  <div class="card-body">
    <div v-if="is_loading" class="text-center py-5 w-100">
      <div class="spinner-border text-secondary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mb-0 text-muted text-xxs">Loading Promo Codes...</p>
    </div>

    <div class="d-flex justify-content-end mb-3">
      <button
        class="btn btn-primary btn-sm btn-info text-xxs text-white rounded shadow-sm dropdown-toggle"
        type="button"
        @click="open_link_promo_code_modal()"
      >
        Add Promo
      </button>
    </div>

    <div v-if="event_promo_codes.length" class="table-responsive" id="promoTabsContent">
      <table class="table table-hover align-middle mb-0">
        <thead class="table-light">
          <tr class="text-xxs text-uppercase text-secondary">
            <th scope="col">Promo Code</th>
            <th scope="col">Type</th>
            <th scope="col">Discount</th>
            <th scope="col">Usage</th>
            <th scope="col">Status</th>
            <th scope="col">Validity</th>
            <th scope="col" class="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in event_promo_codes" :key="item.id">
            <td class="fw-bold text-dark text-xxs">{{ item?.promo_code_name }}</td>
            <td class="text-xxs">
              <span class="badge bg-banner-gradient rounded border text-xxs">
                {{ item?.promo_code?.promo_code_type?.name || 'fixed' }}
              </span>
            </td>
            <td class="text-xxs fw-500 text-primary">
              <span v-if="item?.promo_code?.promo_code_type?.name === 'percentage'">
                {{ item?.promo_code?.discount_amount || 0 }}%
              </span>
              <span v-else>
                R{{ item?.promo_code?.discount_amount || 0 }}
              </span>
            </td>
            <td class="text-xxs">
              <span class="badge bg-light text-dark" v-if="item.has_usage_limit">
                {{ item.usage_count }} / {{ item.usage_limit }}
              </span>
              <span v-else class="badge bg-light text-dark">
                {{ item.usage_count }} / <i class="bi bi-infinity fw-500"></i>
              </span>
            </td>
            <td class="text-center">
              <div class="form-check form-switch d-inline-block">
                <input class="form-check-input" type="checkbox" role="switch"
                  :id="'switch-inline-' + item.id" :checked="item.is_active" @change="toggle_promo_status(item)">
              </div>
            </td>
            <td class="text-xxs">
              <div>Starts: {{ new Date(item.valid_start_date).toLocaleDateString() }}</div>
              <div class="text-danger">Ends: {{ new Date(item.valid_end_date).toLocaleDateString() }}</div>
            </td>
            <td class="text-end">
              <button class="btn btn-sm text-primary me-2" title="Edit Linked Promo Code" @click.stop="open_edit_event_promo_code_modal(item)">
                <i class="bi bi-pencil-square"></i>
              </button>
              <button class="btn btn-sm text-danger" title="Remove From Event" @click.stop="delete_event_promo_code(item)">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <div class="text-center py-4 text-muted text-xxs">
        No promo codes yet.
      </div>
    </div>
  </div>
</div>

<teleport v-else to="body">
  <div class="modal fade" id="promo_code_manager_modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content rounded shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-xxs fw-500 text-white">Promo Codes</h5>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="reset_form"
          ></button>
        </div>

        <div class="modal-body">
          <div class="d-flex justify-content-end mb-3">
              <button
                class="btn btn-primary btn-sm btn-info text-xxs text-white rounded shadow-sm dropdown-toggle"
                type="button"
                @click="open_link_promo_code_modal()"
              >
                Promo Code
              </button>
          </div>
           <div v-if="is_loading" class="text-center py-5 w-100">
            <div class="spinner-border text-secondary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mb-0 text-muted text-xxs">Loading Promo Codes...</p>
          </div>

          <div v-else-if="event_promo_codes.length" class="table-responsive" id="promoTabsContent">
            <table class="table table-hover align-middle mb-0">
              <thead class="table-light">
                <tr class="text-xxs text-uppercase text-secondary">
                  <th scope="col">Promo Code</th>
                  <th scope="col">Type</th>
                  <th scope="col">Discount</th>
                  <th scope="col">Usage</th>
                  <th scope="col">Status</th>
                  <th scope="col">Validity</th>
                  <th scope="col" class="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in event_promo_codes" :key="item.id">
                  <td class="fw-bold text-dark text-xxs">{{ item?.promo_code_name }}</td>
                  <td class="text-xxs">
                    <span class="badge bg-banner-gradient rounded border text-xxs">
                      {{ item?.promo_code?.promo_code_type?.name || 'fixed' }}
                    </span>
                  </td>
                  <td class="text-xxs fw-500 text-primary">
                    <span v-if="item?.promo_code?.promo_code_type?.name === 'percentage'">
                      {{ item?.promo_code?.discount_amount || 0 }}%
                    </span>
                    <span v-else>
                      R{{ item?.promo_code?.discount_amount || 0 }}
                    </span>
                  </td>
                  <td class="text-xxs">
                    <span class="badge bg-light text-dark" v-if="item.has_usage_limit">
                      {{ item.usage_count }} / {{ item.usage_limit }}
                    </span>
                    <span v-else class="badge bg-light text-dark">
                      {{ item.usage_count }} / <i class="bi bi-infinity fw-500"></i>
                    </span>
                  </td>
                  <td class="text-center">
                    <div class="form-check form-switch d-inline-block">
                      <input class="form-check-input" type="checkbox" role="switch"
                        :id="'switch-' + item.id" :checked="item.is_active" @change="toggle_promo_status(item)">
                      <label class="form-check-label text-xxs" :for="'switch-' + item.id">
                        {{ item.is_active ? 'Active' : 'Inactive' }}
                      </label>
                    </div>
                  </td>
                  <td class="text-xxs">
                    <div>Starts: {{ new Date(item.valid_start_date).toLocaleDateString() }}</div>
                    <div class="text-danger">Ends: {{ new Date(item.valid_end_date).toLocaleDateString() }}</div>
                  </td>
                  <td class="text-end">
                    <button class="btn btn-sm text-primary me-2" title="Edit Linked Promo Code" @click.stop="open_edit_event_promo_code_modal(item)">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                    <button class="btn btn-sm text-danger" title="Remove From Event" @click.stop="delete_event_promo_code(item)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else="!event_promo_codes.length">
            <div colspan="8" class="text-center py-4 text-muted text-xxs">
              No promo codes linked yet.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<!-- Link Promo Code Modal -->
<teleport to="body">
  <div class="modal fade" id="link_promo_code_modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content rounded shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-xxs fw-500 text-white">
            {{ is_editing_event_promo ? 'Edit Promo Code' : 'Create Promo Code' }}
          </h5>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="close_child_modal"
          ></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="link_promo_form" novalidate>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Discount Type <span class="text-danger">*</span></label>
                <select class="form-select rounded-3 text-xxs" v-model="discount_type">
                  <option v-for="option in discount_types" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </option>
                </select>
                <p v-if="promo_errors.discount_type" class="text-danger text-xxs">{{ promo_errors.discount_type }}</p>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Discount Value <span class="text-danger">*</span></label>
                <div class="position-relative">
                  <input
                    type="text"
                    class="form-control rounded text-xxs"
                    v-model="discount_value"
                    placeholder="Type or select a discount value"
                    @focus="show_discount_value_dropdown = true"
                    @input="show_discount_value_dropdown = true"
                    @blur="show_discount_value_dropdown = false"
                    autocomplete="off"
                  />
                  <ul
                    class="dropdown-menu w-100 max-h-200"
                    :class="{ show: show_discount_value_dropdown && filtered_discount_values.length }"
                  >
                    <li
                      v-for="value in filtered_discount_values"
                      :key="`discount-${value}`"
                    >
                      <button
                        class="dropdown-item text-xxs"
                        type="button"
                        @mousedown.prevent="discount_value = value; show_discount_value_dropdown = false"
                      >
                        {{ value }}
                      </button>
                    </li>
                  </ul>
                </div>
                <p v-if="promo_errors.discount_value" class="text-danger text-xxs">{{ promo_errors.discount_value }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Valid start date <span class="text-danger">*</span></label>
                <input type="datetime-local" class="form-control rounded text-xxs" v-model="start_date"/>
                <p v-if="promo_errors.start_date" class="text-danger text-xxs">{{ promo_errors.start_date }}</p>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Valid end date <span class="text-danger">*</span></label>
                <input type="datetime-local" class="form-control rounded text-xxs" v-model="end_date"/>
                <p v-if="promo_errors.end_date" class="text-danger text-xxs">{{ promo_errors.end_date }}</p>
              </div>
            </div>

            <div class="row align-items-end">
              <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Usage Limit</label>
                <input type="number" class="form-control rounded text-xxs" v-model.number="usage_limit" placeholder="e.g. 100"/>
              </div>
              <div class="col-md-6 mb-3">
                <div class="form-check pb-2">
                  <input type="checkbox" class="form-check-input" id="is_active" v-model="is_active">
                  <label class="form-check-label text-xxs fw-500" for="is_active">Active</label>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2 mt-4">
              <button type="submit" class="btn btn-primary btn-sm btn-info text-xxs text-white rounded shadow-sm" @click="submit_form">
                {{ is_editing_event_promo ? 'Update' : 'Create' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</teleport>

